const navItems = [
    {
        'id': 1,
        'name': 'Home',
        'link': '/'
    },
    {
        'id': 2,
        'name': 'Plants',
        'link': '/plants'
    },
    {
        'id': 3,
        'name': 'About Us',
        'link': "/about"
    },
    {
        'id': 4,
        'name': 'Care Tips',
        'link': "/care"
    },
    {
        'id': 5,
        'name': 'Community',
        'link': "/community"
    },
];

export default navItems;
